export enum ArcGisSecurityTypes {
  Public,
  Password,
  Token,
  Ntlm,
  VGisAccount
}
